import { Dialog } from "app/dialogs/model/model";
import { UserContent } from "app/profile/model/model";

interface LocalisedText {
  [language: string]: string;
}

export interface Content {
  _id: string;
  title: LocalisedText;
  description: LocalisedText;
  keywords?: LocalisedText;
  productId: string;
  pausable: boolean;
  orderno: number;
  weeks: number;
  leadersOnly: boolean;
  items: Array<ContentItem>;
  userdata?: UserContent; // wird von CModules verwendet
}

export interface ContentItem {
  _id: string;
  day: number;
}

// Content with dialogs and answers
export interface ContentFlow {
  _id: string;
  dialogs: [Dialog];
}